import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import DialogSnackbar from './DialogSnackbar';
import ClientProvider from './client';
export default createDemo(import.meta.url, DialogSnackbar, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/snackbars/demos/dialog-snackbar/DialogSnackbar.tsx",
    "fileName": "DialogSnackbar.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Button from '@mui/material/Button';\nimport Dialog from '@mui/material/Dialog';\nimport DialogActions from '@mui/material/DialogActions';\nimport DialogContent from '@mui/material/DialogContent';\nimport DialogContentText from '@mui/material/DialogContentText';\nimport DialogTitle from '@mui/material/DialogTitle';\nimport Snackbar from '@mui/material/Snackbar';\nimport type { SnackbarCloseReason } from '@mui/material/Snackbar';\n\nexport default function DialogSnackbar() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [dialogOpen, setDialogOpen] = React.useState(false);\n  const [snackbarOpen, setSnackbarOpen] = React.useState(false);\n\n  const handleDialogClose = () => {\n    setDialogOpen(false);\n    setSnackbarOpen(false);\n  };\n\n  const handleSnackbarClose = (\n    _event: React.SyntheticEvent | Event,\n    reason: SnackbarCloseReason,\n  ) => {\n    if (reason === 'clickaway') {\n      return;\n    }\n    setSnackbarOpen(false);\n  };\n\n  return (\n    <React.Fragment>\n      <Button onClick={() => setDialogOpen(true)}>Open dialog</Button>\n      <Dialog\n        open={dialogOpen}\n        onClose={(_event, reason) => {\n          if (reason === 'escapeKeyDown' && snackbarOpen) {\n            setSnackbarOpen(false);\n            return;\n          }\n          handleDialogClose();\n        }}\n        aria-labelledby=\"snackbar-dialog-title\"\n        aria-describedby=\"snackbar-dialog-description\"\n      >\n        <DialogTitle id=\"snackbar-dialog-title\">Snackbar in a dialog</DialogTitle>\n        <DialogContent>\n          <DialogContentText id=\"snackbar-dialog-description\">\n            Show the snackbar, then press Escape to close it. Press Escape again to\n            close the dialog.\n          </DialogContentText>\n        </DialogContent>\n        <DialogActions>\n          <Button onClick={handleDialogClose}>Close</Button>\n          <Button onClick={() => setSnackbarOpen(true)}>Show snackbar</Button>\n        </DialogActions>\n        <Snackbar\n          open={snackbarOpen}\n          onClose={handleSnackbarClose}\n          message=\"Press Escape to close this snackbar\"\n        />\n      </Dialog>\n    </React.Fragment>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 64,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Button from '@mui/material/Button';\nimport Dialog from '@mui/material/Dialog';\nimport DialogActions from '@mui/material/DialogActions';\nimport DialogContent from '@mui/material/DialogContent';\nimport DialogContentText from '@mui/material/DialogContentText';\nimport DialogTitle from '@mui/material/DialogTitle';\nimport Snackbar from '@mui/material/Snackbar';\nimport type { SnackbarCloseReason } from '@mui/material/Snackbar';\n\nexport default function DialogSnackbar() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [dialogOpen, setDialogOpen] = React.useState(false);\n  const [snackbarOpen, setSnackbarOpen] = React.useState(false);\n\n  const handleDialogClose = () => {\n    setDialogOpen(false);\n    setSnackbarOpen(false);\n  };\n\n  const handleSnackbarClose = (\n    _event: React.SyntheticEvent | Event,\n    reason: SnackbarCloseReason,\n  ) => {\n    if (reason === 'clickaway') {\n      return;\n    }\n    setSnackbarOpen(false);\n  };\n\n  return (\n    <React.Fragment>\n      <Button onClick={() => setDialogOpen(true)}>Open dialog</Button>\n      <Dialog\n        open={dialogOpen}\n        onClose={(_event, reason) => {\n          if (reason === 'escapeKeyDown' && snackbarOpen) {\n            setSnackbarOpen(false);\n            return;\n          }\n          handleDialogClose();\n        }}\n        aria-labelledby=\"snackbar-dialog-title\"\n        aria-describedby=\"snackbar-dialog-description\"\n      >\n        <DialogTitle id=\"snackbar-dialog-title\">Snackbar in a dialog</DialogTitle>\n        <DialogContent>\n          <DialogContentText id=\"snackbar-dialog-description\">\n            Show the snackbar, then press Escape to close it. Press Escape again to\n            close the dialog.\n          </DialogContentText>\n        </DialogContent>\n        <DialogActions>\n          <Button onClick={handleDialogClose}>Close</Button>\n          <Button onClick={() => setSnackbarOpen(true)}>Show snackbar</Button>\n        </DialogActions>\n        <Snackbar\n          open={snackbarOpen}\n          onClose={handleSnackbarClose}\n          message=\"Press Escape to close this snackbar\"\n        />\n      </Dialog>\n    </React.Fragment>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 64,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Button",
      "@mui/material/Dialog",
      "@mui/material/DialogActions",
      "@mui/material/DialogContent",
      "@mui/material/DialogContentText",
      "@mui/material/DialogTitle",
      "@mui/material/Snackbar"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
